import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { FinancialConvoContext } from "FinancialConvoContextWrapper";
import { FinancialConvo } from "models/FinancialConvo";
import { OUTCOMES } from "../../../constants";
import { SingleTextForm } from "../shared/SingleTextForm";

export const AnythingElseScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, user } = useAuthContext()
  const { latestFinancialConvo, setLatestFinancialConvo } = useContext(
    FinancialConvoContext
  );
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (anythingElse: string): Promise<boolean> => {
    if (!currentScreen) throw new Error("couldn't determine currentScreen");

    if (!activeEstate?.id || !user?.id) {
      throw new Error("couldn't determine activeEstate or user");
    }

    const financialConvo = latestFinancialConvo || new FinancialConvo();
    financialConvo.anythingElseToKnow = anythingElse;

    try {
      await financialConvo.saveRequest(activeEstate.id, user.id);
      setLatestFinancialConvo && setLatestFinancialConvo(financialConvo);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper title="We’re about wrapped up here—anything else we should know?">
      <SingleTextForm
        multiline
        initText={latestFinancialConvo?.anythingElseToKnow}
        textLabel="Let us know"
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
        charLimit={800}
        required={false}
        rows={10}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
